import { Button, Flex, Text } from "@chakra-ui/react"

type PaginationFooterProps = {
  hasNextPage?: boolean
  hasPreviousPage?: boolean
  mt?: number | string
  onChangePage: (newPage: number) => void
  page: number
}

export function PaginationFooter({
  hasNextPage,
  hasPreviousPage,
  mt = 4,
  onChangePage,
  page,
}: PaginationFooterProps) {
  return (
    <Flex
      gap={2}
      alignItems="center"
      mt={mt}
      direction="row"
      justifyContent="flex-end"
      wrap="wrap"
    >
      <Button
        size="sm"
        onClick={() => onChangePage(page - 1)}
        isDisabled={!hasPreviousPage || page <= 1}
      >
        Poprzedni
      </Button>
      {/*<span>Strona {page}</span>*/}
      <Text fontSize="sm">Strona {page}</Text>
      <Button
        size="sm"
        isDisabled={!hasNextPage}
        onClick={() => onChangePage(page + 1)}
      >
        Dalej
      </Button>
    </Flex>
  )
}
